var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnramp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat_onramp",
    enableBackground: "new 0 0 512 512",
    height: 52,
    viewBox: "0 0 512 512",
    width: 52,
    style: {
      fill: "#fff"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 196c-33.084 0-60 26.916-60 60s26.916 60 60 60 60-26.916 60-60-26.916-60-60-60zm0 80c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 376,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452 36h-392c-33.084 0-60 26.916-60 60v80c0 33.084 26.916 60 60 60h60v220c0 11.046 8.954 20 20 20h232c11.046 0 20-8.954 20-20v-220h60c33.084 0 60-26.916 60-60v-80c0-33.084-26.916-60-60-60zm-100 400h-192v-280h192zm120-260c0 11.028-8.972 20-20 20h-60v-40h20c11.046 0 20-8.954 20-20s-8.954-20-20-20h-312c-11.046 0-20 8.954-20 20s8.954 20 20 20h20v40h-60c-11.028 0-20-8.972-20-20v-80c0-11.028 8.972-20 20-20h392c11.028 0 20 8.972 20 20z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnramp);
export default __webpack_public_path__ + "static/media/onramp.a935baf675ae42be218e971b1f161e80.svg";
export { ForwardRef as ReactComponent };